import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import DynamicValues from './DynamicValues';
import ClientProvider from './client';
export default createDemo(import.meta.url, DynamicValues, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/system/getting-started/the-sx-prop/demos/dynamic-values/DynamicValues.tsx",
    "fileName": "DynamicValues.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport Box from '@mui/material/Box';\nimport Stack from '@mui/material/Stack';\nimport Typography from '@mui/material/Typography';\n\nexport default function DynamicValues() {\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 0,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  const [color, setColor] = React.useState('#007fff');\n\n  return (\n    <Stack spacing={1} sx={{ alignItems: 'center' }}>\n      <Typography\n        component=\"label\"\n        variant=\"body2\"\n        sx={{ display: 'inline-flex', alignItems: 'center', gap: 1 }}\n      >\n        Pick a color to see a live preview\n        <input\n          type=\"color\"\n          value={color}\n          onChange={(event) => setColor(event.target.value)}\n        />\n      </Typography>\n      <Box\n        component=\"div\"\n        sx={{\n          display: 'flex',\n          justifyContent: 'center',\n          alignItems: 'center',\n          width: 75,\n          height: 75,\n          borderRadius: 2,\n          backgroundColor: 'var(--bg)',\n        }}\n        style={{ '--bg': color } as React.CSSProperties}\n      />\n    </Stack>\n  );\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 38,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport Box from '@mui/material/Box';\nimport Stack from '@mui/material/Stack';\nimport Typography from '@mui/material/Typography';\n\nexport default function DynamicValues() {\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 0
        },
        "  const [color, setColor] = React.useState('#007fff');\n\n  return (\n    <Stack spacing={1} sx={{ alignItems: 'center' }}>\n      <Typography\n        component=\"label\"\n        variant=\"body2\"\n        sx={{ display: 'inline-flex', alignItems: 'center', gap: 1 }}\n      >\n        Pick a color to see a live preview\n        <input\n          type=\"color\"\n          value={color}\n          onChange={(event) => setColor(event.target.value)}\n        />\n      </Typography>\n      <Box\n        component=\"div\"\n        sx={{\n          display: 'flex',\n          justifyContent: 'center',\n          alignItems: 'center',\n          width: 75,\n          height: 75,\n          borderRadius: 2,\n          backgroundColor: 'var(--bg)',\n        }}\n        style={{ '--bg': color } as React.CSSProperties}\n      />\n    </Stack>\n  );\n"
      ],
      [
        "span",
        "frame",
        "}\n"
      ]
    ],
    "totalLines": 38,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/Box",
      "@mui/material/Stack",
      "@mui/material/Typography"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
